
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sustainability-certification-organizations-in-fashion",
      function () {
        return require("private-next-pages/sustainability-certification-organizations-in-fashion.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sustainability-certification-organizations-in-fashion"])
      });
    }
  